module.exports = __webpack_public_path__ + "img/barach_yes.a73ebe18.png";